import React, { useEffect } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Section } from 'components/shared';
import pageTypes from 'utils/pageTypes';
import useMetroSearchMarketPromotionCard from 'utils/hooks/useMetroSearchMarketPromotionCard';
import TitlePromotionCTA from 'components/components/organisms/TitlePromotionCTA';

const MarketPromotionBanner = ({ fields }) => {
  const currentPageType = getFieldValue(fields, 'currentPageType');
  const marketPromotion = getFieldValue(fields, 'marketPromotion');
  const marketPromotions = getFieldValue(fields, 'marketPromotions') || [];

  const { updateMetroSearchMarketPromotions } =
    useMetroSearchMarketPromotionCard();
  useEffect(() => {
    if (currentPageType === pageTypes.MetroSearch)
      updateMetroSearchMarketPromotions(marketPromotions);
  }, [marketPromotions, updateMetroSearchMarketPromotions]);
  if (currentPageType === pageTypes.MetroSearch) return '';

  if (!marketPromotion) return '';
  const promotion = {
    logo: marketPromotion.logo && marketPromotion.logo.src,
    logoAlt: marketPromotion.logo && marketPromotion.logo.alt,
    heading: marketPromotion.title,
    title: marketPromotion.offerText,
    rateLabel: marketPromotion.offerSubtext,
    description: marketPromotion.text,
    cta: {
      text:
        marketPromotion.ctaText ||
        (marketPromotion.ctaLink && marketPromotion.ctaLink.text),
      href: marketPromotion.ctaLink && marketPromotion.ctaLink.href,
      target: marketPromotion.ctaLink && marketPromotion.ctaLink.target,
    },
  };

  return (
    <Section>
      <TitlePromotionCTA promotion={promotion} />
    </Section>
  );
};

export default MarketPromotionBanner;
